import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import Field, { describedBy } from "@/components/Field";
import FormDialog from "@/components/FormDialog";
import { createInvitation } from "../../utils";
import useOrganization from "../../hooks/useOrganization";

interface Props {
  open: boolean;
  onClose(invited?: { email: string; token: string }): void;
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const InviteMemberModal: React.FC<Props> = ({ open, onClose }) => {
  const organization = useOrganization();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setEmail("");
      setSubmitted(false);
      setError(null);
    }
  }, [open]);

  const handleSubmit = async () => {
    setSubmitted(true);
    if (!EMAIL.test(email.trim())) return;
    setSubmitting(true);
    setError(null);
    try {
      const { invitation, token } = await createInvitation(organization, email.trim());
      onClose({ email: invitation.email, token });
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  const emailError =
    submitted && !EMAIL.test(email.trim()) ? "Vul een geldig e-mailadres in" : null;

  return (
    <FormDialog
      open={open}
      onOpenChange={(next) => !next && onClose()}
      title="Lid uitnodigen"
      description="Je krijgt een link die je zelf naar de nieuwe beheerder stuurt."
      submitLabel="Uitnodiging maken"
      submitting={submitting}
      error={error}
      onSubmit={handleSubmit}
    >
      <Field id="invite-email" label="E-mailadres" error={emailError}>
        <Input
          id="invite-email"
          type="email"
          autoComplete="off"
          value={email}
          aria-invalid={emailError != null}
          aria-describedby={describedBy("invite-email")}
          onChange={(e) => {
            setEmail(e.target.value);
            setError(null);
          }}
        />
      </Field>
    </FormDialog>
  );
};

export default InviteMemberModal;
